// utils/loadScripts.js
function loadSingleScript(src) {
  return new Promise((resolve, reject) => {
    // 检查是否已加载，避免重复
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = () => reject(new Error(`加载失败: ${src}`));
    document.head.appendChild(script);
  });
}

export async function loadScriptsInOrder(srcList) {
  for (const src of srcList) {
    await loadSingleScript(src); // 逐个加载，前一个完成再加载下一个
  }
}



// WEBPACK FOOTER //
// ./src/utils/loadScripts.js